module.exports = __webpack_public_path__ + "img/en-calculator-frame.d219b6aa.png";